/**
 * Custom SVG icon library for the site.
 *
 * Every icon renders at the parent's width/height — wrap in a sized container.
 * Add new icons here and reference by key in pattern/agent data.
 */


export const Brain = () => (
  <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M40 10c-8 0-15 4-19 10-3 5-4 11-2 17 1 3 3 6 5 8l2 3c1 3 2 6 2 9v3h24v-3c0-3 1-6 2-9l2-3c2-2 4-5 5-8 2-6 1-12-2-17-4-6-11-10-19-10z" fill="url(#brain-g)" opacity="0.9"/>
    <path d="M33 45v15M40 45v18M47 45v15" stroke="#38bdf8" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="33" cy="62" r="2" fill="#38bdf8"/><circle cx="40" cy="65" r="2" fill="#a78bfa"/><circle cx="47" cy="62" r="2" fill="#38bdf8"/>
    <path d="M28 28c0-3 2-5 5-5s5 2 5 5M42 28c0-3 2-5 5-5s5 2 5 5" stroke="#e2e8f0" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M33 30c2 3 5 4 7 4s5-1 7-4" stroke="#e2e8f0" strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="33" cy="24" r="1.5" fill="#38bdf8"/><circle cx="47" cy="24" r="1.5" fill="#a78bfa"/>
    <defs><linearGradient id="brain-g" x1="20" y1="10" x2="60" y2="60"><stop stopColor="#38bdf8" stopOpacity="0.3"/><stop offset="1" stopColor="#a78bfa" stopOpacity="0.3"/></linearGradient></defs>
  </svg>
);

export const Prompt = () => (
  <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="12" y="14" width="56" height="52" rx="6" fill="#131829" stroke="#38bdf8" strokeWidth="1.5"/>
    <path d="M22 28l8 6-8 6" stroke="#38bdf8" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="34" y1="40" x2="54" y2="40" stroke="#a78bfa" strokeWidth="2" strokeLinecap="round"/>
    <line x1="22" y1="50" x2="42" y2="50" stroke="#475569" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="22" y1="56" x2="36" y2="56" stroke="#475569" strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="58" cy="22" r="6" fill="#38bdf8" opacity="0.2"/>
    <path d="M56 22l2 2 3-4" stroke="#38bdf8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const Agent = () => (
  <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="40" cy="28" r="14" fill="#131829" stroke="#a78bfa" strokeWidth="1.5"/>
    <circle cx="35" cy="25" r="2" fill="#a78bfa"/><circle cx="45" cy="25" r="2" fill="#a78bfa"/>
    <path d="M35 32c2 2 3 3 5 3s3-1 5-3" stroke="#a78bfa" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M26 42c-3 2-6 6-6 12h40c0-6-3-10-6-12" stroke="#a78bfa" strokeWidth="1.5" strokeLinecap="round"/>
    <rect x="30" y="42" width="20" height="16" rx="3" fill="#131829" stroke="#a78bfa" strokeWidth="1.5"/>
    <line x1="36" y1="48" x2="44" y2="48" stroke="#38bdf8" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="36" y1="52" x2="42" y2="52" stroke="#38bdf8" strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="16" cy="28" r="3" fill="#38bdf8" opacity="0.3"/><circle cx="64" cy="28" r="3" fill="#38bdf8" opacity="0.3"/>
    <line x1="19" y1="28" x2="26" y2="28" stroke="#38bdf8" strokeWidth="1" strokeDasharray="2 2"/>
    <line x1="54" y1="28" x2="61" y2="28" stroke="#38bdf8" strokeWidth="1" strokeDasharray="2 2"/>
  </svg>
);

export const MCP = () => (
  <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="8" y="30" width="18" height="20" rx="3" fill="#131829" stroke="#34d399" strokeWidth="1.5"/>
    <rect x="54" y="14" width="18" height="16" rx="3" fill="#131829" stroke="#38bdf8" strokeWidth="1.5"/>
    <rect x="54" y="34" width="18" height="16" rx="3" fill="#131829" stroke="#a78bfa" strokeWidth="1.5"/>
    <rect x="54" y="54" width="18" height="16" rx="3" fill="#131829" stroke="#fb923c" strokeWidth="1.5"/>
    <rect x="30" y="26" width="16" height="28" rx="4" fill="url(#mcp-g)" stroke="#38bdf8" strokeWidth="1.5"/>
    <path d="M26 40h4M46 22h8M46 42h8M46 62h8" stroke="#475569" strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="38" cy="36" r="2" fill="#38bdf8"/><circle cx="38" cy="44" r="2" fill="#a78bfa"/>
    <defs><linearGradient id="mcp-g" x1="30" y1="26" x2="46" y2="54"><stop stopColor="#1e293b"/><stop offset="1" stopColor="#0f172a"/></linearGradient></defs>
  </svg>
);

export const RAG = () => (
  <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="10" y="12" width="24" height="30" rx="2" fill="#131829" stroke="#fb923c" strokeWidth="1.5"/>
    <line x1="16" y1="20" x2="28" y2="20" stroke="#475569" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="16" y1="26" x2="26" y2="26" stroke="#475569" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="16" y1="32" x2="28" y2="32" stroke="#475569" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M34 28l8 4" stroke="#fb923c" strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="48" cy="36" r="10" fill="#131829" stroke="#38bdf8" strokeWidth="1.5"/>
    <path d="M44 36l3 3 5-6" stroke="#38bdf8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M48 46v6" stroke="#38bdf8" strokeWidth="1.5" strokeLinecap="round"/>
    <rect x="36" y="54" width="24" height="14" rx="3" fill="#131829" stroke="#a78bfa" strokeWidth="1.5"/>
    <line x1="42" y1="60" x2="54" y2="60" stroke="#a78bfa" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="42" y1="64" x2="50" y2="64" stroke="#a78bfa" strokeWidth="1" strokeLinecap="round"/>
  </svg>
);

export const MultiAgent = () => (
  <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="40" cy="40" r="8" fill="#131829" stroke="#38bdf8" strokeWidth="2"/>
    <text x="40" y="44" textAnchor="middle" fill="#38bdf8" fontSize="10" fontWeight="bold">O</text>
    <circle cx="20" cy="18" r="6" fill="#131829" stroke="#a78bfa" strokeWidth="1.5"/>
    <circle cx="60" cy="18" r="6" fill="#131829" stroke="#34d399" strokeWidth="1.5"/>
    <circle cx="16" cy="55" r="6" fill="#131829" stroke="#fb923c" strokeWidth="1.5"/>
    <circle cx="64" cy="55" r="6" fill="#131829" stroke="#f472b6" strokeWidth="1.5"/>
    <circle cx="40" cy="68" r="6" fill="#131829" stroke="#fbbf24" strokeWidth="1.5"/>
    <line x1="26" y1="22" x2="34" y2="34" stroke="#a78bfa" strokeWidth="1" opacity="0.5"/>
    <line x1="54" y1="22" x2="46" y2="34" stroke="#34d399" strokeWidth="1" opacity="0.5"/>
    <line x1="20" y1="50" x2="34" y2="44" stroke="#fb923c" strokeWidth="1" opacity="0.5"/>
    <line x1="60" y1="50" x2="46" y2="44" stroke="#f472b6" strokeWidth="1" opacity="0.5"/>
    <line x1="40" y1="62" x2="40" y2="48" stroke="#fbbf24" strokeWidth="1" opacity="0.5"/>
  </svg>
);

export const Guardrails = () => (
  <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M40 12l22 12v20c0 12-9 20-22 26-13-6-22-14-22-26V24l22-12z" fill="#131829" stroke="#34d399" strokeWidth="1.5"/>
    <path d="M40 20l14 8v14c0 8-6 14-14 18-8-4-14-10-14-18V28l14-8z" fill="#34d399" opacity="0.1"/>
    <path d="M34 40l4 4 8-10" stroke="#34d399" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const Skills = () => (
  <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="14" y="18" width="22" height="18" rx="3" fill="#131829" stroke="#38bdf8" strokeWidth="1.5"/>
    <rect x="44" y="18" width="22" height="18" rx="3" fill="#131829" stroke="#a78bfa" strokeWidth="1.5"/>
    <rect x="14" y="44" width="22" height="18" rx="3" fill="#131829" stroke="#34d399" strokeWidth="1.5"/>
    <rect x="44" y="44" width="22" height="18" rx="3" fill="#131829" stroke="#fb923c" strokeWidth="1.5"/>
    <circle cx="25" cy="27" r="3" fill="#38bdf8" opacity="0.3"/>
    <circle cx="55" cy="27" r="3" fill="#a78bfa" opacity="0.3"/>
    <circle cx="25" cy="53" r="3" fill="#34d399" opacity="0.3"/>
    <circle cx="55" cy="53" r="3" fill="#fb923c" opacity="0.3"/>
  </svg>
);

export const PromptLibrary = () => (
  <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="10" y="10" width="26" height="32" rx="3" fill="#131829" stroke="#38bdf8" strokeWidth="1.5"/>
    <line x1="16" y1="18" x2="30" y2="18" stroke="#38bdf8" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="16" y1="24" x2="28" y2="24" stroke="#475569" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="16" y1="30" x2="30" y2="30" stroke="#475569" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="16" y1="36" x2="24" y2="36" stroke="#475569" strokeWidth="1.5" strokeLinecap="round"/>
    <rect x="27" y="22" width="26" height="32" rx="3" fill="#131829" stroke="#a78bfa" strokeWidth="1.5"/>
    <line x1="33" y1="30" x2="47" y2="30" stroke="#a78bfa" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="33" y1="36" x2="45" y2="36" stroke="#475569" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="33" y1="42" x2="47" y2="42" stroke="#475569" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="33" y1="48" x2="41" y2="48" stroke="#475569" strokeWidth="1.5" strokeLinecap="round"/>
    <rect x="44" y="34" width="26" height="32" rx="3" fill="#131829" stroke="#34d399" strokeWidth="1.5"/>
    <line x1="50" y1="42" x2="64" y2="42" stroke="#34d399" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="50" y1="48" x2="62" y2="48" stroke="#475569" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="50" y1="54" x2="64" y2="54" stroke="#475569" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="50" y1="60" x2="58" y2="60" stroke="#475569" strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="62" cy="18" r="10" fill="#131829" stroke="#38bdf8" strokeWidth="1.5"/>
    <path d="M59 18l2 2 4-5" stroke="#38bdf8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// ─── UI Icons ──────────────────────────────────────────────────────────────

export const ArrowRight = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14M12 5l7 7-7 7"/>
  </svg>
);

export const ArrowLeft = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M19 12H5M12 19l-7-7 7-7"/>
  </svg>
);

export const MenuIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M3 12h18M3 6h18M3 18h18"/></svg>
);

export const CloseIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
);

export const HomeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
);

export const SearchIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
);

export const CopyIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg>
);

/**
 * Lookup helper — returns a component by string key.
 * Used by data-driven rendering in pages.
 */
const iconMap = { Brain, Prompt, Agent, MCP, RAG, MultiAgent, Guardrails, Skills, PromptLibrary };

// eslint-disable-next-line react-refresh/only-export-components
export function getIcon(name) {
  return iconMap[name] || null;
}
